import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DelegationService } from 'src/app/delegation/services/delegation.service';
import { AdminConstants } from '../constants/user-constants/admin.constants';
import { USER_ROLE } from '../constants/user-role.enum';
import { ViewDetails } from '../models/view-details.model';
import { AccountManagerService } from './account-manager.service';
import { AdminService } from './admin.service';
import { EmployeeService } from './employee.service';
import { LoggedInUserService } from './logged-in-user.service';
import { OperationEmployeeService } from './operation-employee.service';
import { OperationShiftManagerService } from './operation-shift-manager.service';
import { RequesterService } from './requester.service';

@Injectable({
    providedIn: 'root'
})
export class SidebarMenuService {
    menuItemActive = new Subject<boolean>();
    updateActiveItem = new BehaviorSubject<number>(0);
    viewType: string;
    viewDetailsObj: ViewDetails;
    activeHeaderMenuItem;

    constructor(
        private adminService: AdminService,
        private employeeService: EmployeeService,
        private requesterService: RequesterService,
        private accountManagerService: AccountManagerService,
        private loggedInUserService: LoggedInUserService,
        private operationShiftManagerService: OperationShiftManagerService,
        private operationEmployeeService: OperationEmployeeService,
        private delegationService: DelegationService,
        private translateService: TranslateService
    ) {}

    getSideMenuBasedOnUserRole(userRole: string) {
        if (userRole === USER_ROLE.ADMIN || userRole === USER_ROLE.SHIFT_MANAGER || userRole === USER_ROLE.SECTION_MANAGER) {
            return this.customActionForSuperAdmin(this.adminService.getSideMenu(userRole));
        }
        if (userRole === USER_ROLE.GENERAL_MANAGER) {
            return this.customActionForSuperAdmin(this.adminService.getSideMenuForGeneralManager(userRole));
        } else if (userRole === USER_ROLE.EMPLOYEE) {
            return this.customActionForSuperAdmin(this.employeeService.getSideMenu());
        } else if (userRole === USER_ROLE.REQUESTER) {
            return this.customActionForSuperAdmin(this.requesterService.getSideMenu());
        } else if (userRole === USER_ROLE.ACCOUNT_MANAGER) {
            return this.customActionForSuperAdmin(this.accountManagerService.getSideMenu());
        } else if (userRole === USER_ROLE.OPERATION_SHIFT_MANAGER) {
            return this.customActionForSuperAdmin(this.operationShiftManagerService.getSideMenu());
        } else if (userRole === USER_ROLE.OPERATION_EMPLOYEE) {
            return this.customActionForSuperAdmin(this.operationEmployeeService.getSideMenu());
        } else {
            return undefined;
        }
    }

    private customActionForSuperAdmin(list: any[]): any[] {
        if (this.loggedInUserService.isSuperAdmin()) {
            const lastIdx = list.length - 3; //make all inquires side menu under header
            list.splice(lastIdx, 0, AdminConstants.SECURITY_COORDINATOR_REQUESTS);
            return list;
        }
        return list;
    }

    getPanelSideMenu() {
        return this.adminService.getPanelSideMenu();
    }

    getFileManagementMenu() {
        return this.adminService.getFileManagementMenu();
    }

    getPeriodicReviewMenu() {
        return this.adminService.getPeriodicReviewMenu();
    }

    /** Get view type based on the active side menu item */
    getViewType() {
        return this.viewDetailsObj.viewType;
    }

    storeViewDetails(viewObject) {
        this.viewDetailsObj = viewObject;
    }

    getViewObject() {
        return this.viewDetailsObj;
    }

    storeActiveHeaderMenuItem(activeHeaderMenuItem) {
        this.activeHeaderMenuItem = activeHeaderMenuItem;
    }

    getActiveHeaderMenuItem() {
        return this.activeHeaderMenuItem;
    }
}
